import {
    GET_ADDRESS,
    GET_ADDRESS_SUCCESS,
    GET_ADDRESS_FAILED,
    HANDLE_INVALID_API_RESPONSE,
    HANDLE_VALID_API_RESPONSE,
    INIT_ADDRESS_FORM,
    SAVE_FORM_DATA_VALUES,
    TRACK_AVAILABILITY_CHECK,
    INIT_APP,
} from './constant';
import { track } from '@vfde-fe/sails_core';
import { addressFoundTracking, addressNotFoundTracking, initTracking } from './helpers/tracking';

/**
 * Export initForm
 *
 * @export initForm
 */
export const initApp = () => {
    return {
        type: INIT_APP,
    };
};

/**
 * Export getAddress
 *
 * @export getAddress
 */
export const getAddress = () => {
    return {
        type: GET_ADDRESS,
    };
};

/**
 * Export handleInvalidApiCall
 *
 * @export handleInvalidApiCall
 */

export const handleInvalidApiCall = () => ({
    type: HANDLE_INVALID_API_RESPONSE,
});

/**
 * Export handleValidApiCall
 *
 * @export handleValidApiCall
 */

export const handleValidApiCall = (responseData) => ({
    type: HANDLE_VALID_API_RESPONSE,
    responseData,
});

/**
 * Export getAddressSuccess
 *
 * @export getAddressSuccess
 */
export const getAddressSuccess = () => {
    return {
        type: GET_ADDRESS_SUCCESS,
    };
};

/**
 * Export getAddressNotFound
 *
 * @export getAddressNotFound
 */
export const getAddressNotFound = () => {
    return {
        type: GET_ADDRESS_FAILED,
    };
};

/**
 * Export initForm
 *
 * @export initForm
 */
export const initForm = () => {
    return {
        type: INIT_ADDRESS_FORM,
    };
};

/**
 * Export saveFormDataValues
 *
 * @export saveFormDataValues
 */
export const saveFormDataValues = (update) => {
    return {
        type: SAVE_FORM_DATA_VALUES,
        update,
    };
};

/**
 * Track the form
 */
const trackForm = (payload: any) => {
    return track(
        {
            type: TRACK_AVAILABILITY_CHECK,
        },
        'pageview',
        payload,
    );
};

/**
 * trackInitialPageView
 */
export const trackInitialPageView = () => {
    const trackingPayload = initTracking();

    return trackForm (trackingPayload);
};

/**
 * track address found
 */
export const trackAddressFound = (addressArt: string, technologie: string) => {
    const trackingPayload = addressFoundTracking(addressArt, technologie);

    return trackForm (trackingPayload);
};

/**
 * track address found
 */
export const trackAddressNotFound = () => {
    const trackingPayload = addressNotFoundTracking();

    return trackForm (trackingPayload);
};
